import { CaseCreationNodeMetaMappedValueValueTypeEnum } from "src/clients/flow-api/api";
import {
  CaseCreationNodeData,
  CaseUpdateNodeData,
} from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";

const extractCaseInputLocation = (
  data: CaseCreationNodeData | CaseUpdateNodeData,
  nodeId: string,
): SearchableField => {
  return {
    id: `${nodeId}:case_input_location`,
    value: `data.${data.case_input_location}`,
  };
};

export const extractUpdateCaseNodeFields = (
  data: CaseUpdateNodeData,
  nodeId: string,
): SearchableField[] => {
  return [extractCaseInputLocation(data, nodeId)];
};

export const extractCreateCaseNodeFields = (
  data: CaseCreationNodeData,
  nodeId: string,
): SearchableField[] => {
  // fixed means the value is selected from a dropdown, dynamic is free input text
  const dynamicMappings = Object.entries(data.details_mapping).flatMap(
    ([key, value]) =>
      value.value_type === CaseCreationNodeMetaMappedValueValueTypeEnum.DYNAMIC
        ? [{ id: `${nodeId}:${key}`, value: value.value }]
        : [],
  );
  return [...dynamicMappings, extractCaseInputLocation(data, nodeId)];
};
